<template>
	<!-- 預留資訊 -->
	<div class="deal_index_box">
		<!-- 内容 -->
			<div class="deal_title">
				<div>個人資訊<span>》</span>預留資訊</div>
				<div class="deal_hr">
					<div class="cut_off"></div>
				</div>
			</div>
			<!-- 預留資訊 -->
			<div class="deal_content_box">
				<div class="deal_content_title">預留資訊</div>
				<!-- 預留資訊修改 -->
				<el-form :model="ruleForm" status-icon :rules="rules2" ref="ruleForm" label-width="0" class="deal_content div_hight_end"
			 v-if="paymentsd">
					<el-row>
						<el-col :span="16" :xs="24" class="list_tile_sed icon_phigt" >
							<i class="el-icon-warning colro-red"></i><span >您正在修改預留資訊，請輸入下列欄位後送出申請。 </span>
						</el-col>
					</el-row>
					<el-form-item class="paind_bottm_end">
						<el-col :span="5" :xs="8" >
							<div class="right_col">
								目前預留資訊：
							</div>
						</el-col>
						<el-col :span="6" :xs="10" class="input_high show_list">
							{{reserved}}
						</el-col>
					</el-form-item>
					<el-form-item class="paind_bottm_end" prop="Reserved">
						<el-col :span="5" :xs="8">
							<div class="right_col"><span class="list_span">*</span>新的預留資訊：</div>
						</el-col>
						<el-col :span="6" :xs="10" class="input_high">
							<el-input v-model="ruleForm.Reserved" type="text" maxlength="10"></el-input>
						</el-col>
					</el-form-item>
					<el-form-item class="paind_bottm_end" prop="trader_password" v-if="traderPassTF">
						<el-col :span="5" :xs="8">
							<div class="right_col"><span class="list_span">*</span>輸入<span class="list_span">交易</span>密碼：</div>
						</el-col>
						<el-col :span="6" :xs="10" class="input_high">
							<el-input v-model="ruleForm.trader_password" type="password" maxlength="6"></el-input>
						</el-col>
						<el-col :span="6">
							<div class="show_list_li cur_div" @click="forget()">忘記交易密碼?</div>
						</el-col>
					</el-form-item>
					<el-form-item class="paind_bottm_end " prop="secret"  v-if="secretTF">
						<el-col :span="5" :xs="8">
							<div class="right_col"><span class="list_span">*</span>google驗證碼：</div>
						</el-col>
						<el-col :span="6" :xs="10" class="input_high">
							<el-input v-model="ruleForm.secret" type="text" maxlength="6"></el-input>
						</el-col>
					</el-form-item>
					<el-form-item class="paind_bottm_end painde_top">
						<el-col :span="15" class="button_cetent">
							<el-button type="danger" plain class="bottom_onew" @click="rouUrl()">返回</el-button>
							<el-button type="danger" class="bottom_two" @click="submitForm()">送出</el-button>
						</el-col>
					</el-form-item>
				</el-form>
				<!-- 修改成功 -->
				<div class="deal_content div_hight_dedt" v-if="paymentslue">
					<el-row>
						<el-col :span="10" :xs="14" class="list_tile_sed icon_phigt" >
							<i class="el-icon-warning colro-red"></i><span >設定完成</span>
						</el-col>
					</el-row>
	
				</div>
			</div>
			<!-- deal_index_box -->
	</div>



</template>

<script>
	import axios from 'axios';
	export default {
		name: 'LoginDealIndex',
		data() {
			//验证原交易密码
			let validatePassl = (rule, value, callback) => {
				if (value === "") {
					this.$message({
						showClose: true,
						message: '請輸入交易密碼',
						type: 'error',
						duration: 1000
					});
				} else if (this.Verification(value)) {
					this.$message({
						showClose: true,
						message: '只能是純數字',
						type: 'error',
						duration: 1000
					});
				} else {
					
					this.ruleForm.trader_password=value
					callback()
				}
			}
			//验证原交易密码
			let validatePasslst = (rule, value, callback) => {
				if (value === "") {
					this.$message({
						showClose: true,
						message: '請輸入google驗證碼',
						type: 'error',
						duration: 1000
					});
				} else if (this.Verification(value)) {
					this.$message({
						showClose: true,
						message: '只能是純數字',
						type: 'error',
						duration: 1000
					});
				} else {
					
					this.ruleForm.secret=value
					callback()
				}
			}
			return {
				traderPassTF:false,
				secretTF:false,
                reserved:'',
				ruleForm: {
					secret:'',
					trader_password: '',
					Reserved: '',
				},
				rules2: {
					secret: [{
						validator: validatePasslst,
						trigger: 'change'
					}],
					trader_password: [{
						validator: validatePassl,
						trigger: 'change'
					}],
				},
				paymentslue: false,
				paymentsd:true,
				// return
			}
		},
		methods: {
			rouUrl(){
			  this.$router.push('/login/account');
			},
			forget() {
				this.$router.push("/login/account/forget");
				this.$store.commit('changeFP',"/login/account/loginap");
			},
			// <!--提交密碼修改-->
			submitForm() {
				if(this.ruleForm.trader_password===''){
					this.$message({
						showClose: true,
						message: '请输入交易密碼',
						type: 'error',
						duration: 1000
					});
					return
				}
				if(this.ruleForm.Reserved===''){
					this.$message({
						showClose: true,
						message: '请输入新的預留信息',
						type: 'error',
						duration: 1000
					});
					return
				}
				axios.get(this.$store.state.axiosReserveUrl, {
					params: {
						uid :this.$store.state.uid,
						secret: this.ruleForm.secret,
						trader_password: this.ruleForm.trader_password,
						reserved: this.ruleForm.Reserved,
						action:1,
					}
				}).then((res) => {
					console.log(res)
						this.message = res.data.message;
						this.status = res.data.status;
						// 修改失敗
						if (!this.status){			
							if (this.status == -1){
								this.$message({
									showClose: true,
									message: '交易密碼有誤，請重新輸入',
									type: 'error',
									duration: 1000
								});
							}else {
								this.$message({
									showClose: true,
									message: this.message,
									type: 'error',
									duration: 1000
								});
							}
						}else{
							this.paymentslue = true;
							this.paymentsd=false;
							this.$store.commit('reservedFun',this.ruleForm.Reserved);
	
						}
						
						
				})
	
			},
			listaccount() {
				this.reserved = this.$store.state.reserved;
				if (this.$store.state.secretTF != '-1') {
					this.traderPassTF = false;
					this.secretTF = true;
				} else {
					if (this.$store.state.traderPassTF != '-1') {
						this.traderPassTF = true;
						this.secretTF = false;
					} 
			
				}
			
			},
			// 限制交易密码
			Verification(str) {
				var pattern = /\D/;
				if (!pattern.test(str)) {
					return false;
				} else {
					return true;
				}
	
			},
			
	
		},
        mounted(){
			this.listaccount()
 
        }
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	/* 表頭 */
	.cur_div {
		cursor: pointer;
	}
	.deal_index_box {
		margin: 20px;
		font-size: 15px;
		color: black;
	}
    .deal_title {
    	display: flex;
    	justify-content: flex-start; 
    	padding-bottom: 10px;
    }
    
    .deal_title span {
    	margin-left: 15px;
    	margin-right: 8px;
    }
    
    .deal_title .deal_hr {
    	flex: 1;
    	margin-left: 18px;
    }
    
    .deal_title .deal_hr .cut_off {
    	height: 3px;
    	background: black;
    	margin-top: 8px;
    }
	/* 内容 */
	.datetime_box>span {
		margin: 10px;
	}

	.deal_content_box {
		font-size: 13px;
		margin-top: 20px;
	}

	.deal_content_title {
		height: 42px;
		background: #666666;
		line-height: 42px;
		color: white;
		padding-left: 14px;
		 
	}

	.deal_content {
		box-sizing: border-box;
		/* height: 53.6vw; */
		min-height: 100px;
		border: 1px solid #666666;
		background: #ffffff;
		padding: 0 20px;
		padding-top: 26px;
	}

	.deal_content_span {
		margin-left: 23px;
		font-size: 11px;
		color: #e73262;
	}

	.deal_content_tab_first {
		width: 960px;
		margin: 0 auto;
	}

	.deal_content_tab_first>div {
		margin: 14px 0;
	}

	.money_box span {
		margin: 0 10px;
	}

	.money_input {
		width: 140px;
		/* margin-left: 4px; */
	}

	.money_input01 {
		margin-left: 4px;
	}

	.inquire_button {
		padding: 10px 0;
	}



	/* 个人资讯 */
	.list_high {
		color: #666666;
		display: flex;
		height: 36px;
		line-height: 36px;
		font-size: 13px;
	}

	.div_hight {
		padding-top: 10px;
	}

	.btn_lits {
		padding-top: 0px;
		padding-bottom: 0px;
		padding-left: 7px;
		padding-right: 7px;
		height: 16px;
		border-top-width: 1px;
		margin-top: 9px;
		margin-left: 10px;
		font-size: 11px;
		background: #e73262;
	}

	.div_hight_end {
		padding-top: 10px;
		
	}

	/* 重設交易密碼 */

	.list_tile_sed {
		background-color: #fff4cc;
		line-height: 40px;
		margin: 25px 100px 25px 25px;

	}

	.colro-red {
		color: #ff4a05;
		font-size: 20px;
	}

	.list_span {
		color: #e73262;
	}

	.right_col {
		float: right;
		padding-top: 7px;
		padding-right: 15px
	}

	.right_col_left {
		color: #4d80e7;
		padding-top: 7px;
		padding-left: 15px
	}

	.list_span_end {
		color: #e73262;
		padding-top: 7px;
		padding-left: 15px;
	}

	.paind_bottm {
		padding-bottom: 80px;
	}
	.p_cetent{
		padding-top: 20px;
	}
	.p_cetent span,.show_list{
		color: #13ae22;
	}
	.show_list{
		padding-top: 7px;
	}
	/deep/.input_high .el-input .el-input__inner{
		height: 27px;
		border: 1px solid #cccccc;
	}
	.paind_bottm_end{
		padding-bottom: 15px;
	}
	.button_cetent{
	    float: right;
		margin-top: 10px;	
		padding-bottom: 25px;
	}
	.button_cetent button{
		height: 22px;
		padding-bottom: 5px;
		padding-top: 2px;
		padding-left: 8px;
		padding-right: 10px;
		width: 45px;
		 
	}
	.bottom_onew{
		color: #e73262;
		border-color: #e73262;
	}
	.bottom_two{
		background: #e73262;

	}
	.icon_phigt span{
		padding-left: 10px;
	}
	.div_hight_dedt{
		min-height: 330px;
		padding-top: 10px;
	}
	.bottn_warning{
		background-color:#ff771a ;
		border-color: #ff771a;
		font-size: 11px;
		padding-top: 2px;
		padding-bottom: 2px;
		padding-left: 5px;
		padding-right: 5px;
		margin-bottom: 5px;
    margin-left: 10px;
	}
	.painde_top{
		padding-top: 100px;
	}
	
	.show_list_li{
		color: #4d80e7;
		padding-left: 20px;
		padding-top: 7px;
	}
	/deep/.deal_content_box .el-form-item__content {
		line-height: 15px;
	}
	/deep/.deal_content_box .el-input__suffix {
		top: -5px;
	}
	
	/deep/.paind_bottm_end>>>.el-form-item__content {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
</style>

